export default "__VITE_ASSET__v2mNCmLK__"